import { render, staticRenderFns } from "./ReprocesarImputacionCobranzasPage.vue?vue&type=template&id=0a96c1c0&scoped=true"
import script from "./ReprocesarImputacionCobranzasPage.vue?vue&type=script&lang=js"
export * from "./ReprocesarImputacionCobranzasPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a96c1c0",
  null
  
)

export default component.exports